import { render, staticRenderFns } from "./CarteraImagen.vue?vue&type=template&id=23160976"
import script from "./CarteraImagen.vue?vue&type=script&lang=js"
export * from "./CarteraImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports